// /import storage from 'electron-storage'
import {isEmpty} from 'lodash'
export function getPublisherColumns() {
    let columns = JSON.parse(localStorage.getItem('publisherColumns'))
    if (!isEmpty(columns)) {
        return columns
    }
    return ['checkbox', '_id', 'name', 'city', 'country', 'publications', 'admin', 'settings']
    }
    
    export function getPublisherTableOptions() {
        return {
            filterByColumn: false,
            perPage:10,
            pagination: { show: false},
            filterable: false,
            headings: {
            _id : 'GUID',
            name: 'Publisher Name',
            city : 'City',
            country: 'Country',
            publications: 'Publications',
            admin: 'Admin',
            settings: 'Settings',
            },
            sortable: ['x'],
            sortIcon: { base: 'as-nova', up: 'nova-tablesortinga-z', down: 'nova-tablesortingz-a', is: 'nova-tablesorting' },
        }
    }
     export function getPublisherTableSettingsOptions() {
         return [
                {key: 'checkbox', value: ('Checkbox') },
                {key: '_id', value: ('GUID')},
                {key: 'name', value: ('Name')},
                {key: 'city', value: ('City')},
                {key: 'country', value: ('Country')},
                {key: 'publications', value: ('Publications')},
                {key: 'admin', value: 'Admin'},
                {key: 'settings', value: ('Settings')},
         ]
         
     }